// import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://uat-api-enterprise.zwiz.app/', // `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lineBotGroupApi = {
  getEstimateReach: (request) => {
    const { pageId } = request
    return instance().post(`api/cms/v1/broadcast/line-bot-group/${pageId}/estimate-reach`)
  },
  postBroadcast: (request) => {
    const { pageId, data } = request
    return instance().post(`api/cms/v1/broadcast/line-bot-group/${pageId}`, data)
  },
  getListBroadcast: (request) => {
    const { pageId, status, limit, offset } = request
    return instance().get(
      `api/cms/v1/broadcast/line-bot-group/${pageId}?status=${status}&limit=${limit}&offset=${offset}`
    )
  },
  deleteBroadcastById: (request) => {
    const { pageId, broadcastId } = request
    return instance().delete(`/api/cms/v1/broadcast/line-bot-group/${pageId}`, {
      data: {
        broadcast_id: broadcastId
      }
    })
  }
}
export default lineBotGroupApi



// WEBPACK FOOTER //
// ./src/api/line-bot-group.js